import { ajaxJson } from 'imports/ajax';
import { createTypes } from 'redux-create-types';


const namespace = 'program-detail';

export const programActions = createTypes([
    'toggleSpinner',
    'setError',
    'setProgram'
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: programActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: programActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function setProgram(program) {
    return dispatch => {
        dispatch({
            type: programActions.setProgram,
            payload: program
        })
    }
}

function getProgramApiFail(err) {
    return dispatch => {
        dispatch({
            type: programActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('program'));
    }
}

function getProgramApiSuccess(res) {
    return dispatch => {
        dispatch(setProgram(res.data));
        return dispatch(hideSpinner('program'));
    }
}

function getProgramFromApi(programId) {
    return dispatch => {
        dispatch(showSpinner('program'));
        return ajaxJson.get(`/programs/${programId}/public`)
        .then(
            res => dispatch(getProgramApiSuccess(res)),
            err => dispatch(getProgramApiFail(err)),
        ).then(() => {
            return dispatch(hideSpinner('program'));
        });
    }
}

export const programDetailActions = {
    getProgramFromApi,
}